/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import style from './description.module.scss';
import '../../../constants/_global.scss';

interface DescriptionInterface {
  childOne?: ReactNode;
  childTwo?: ReactNode;
  title: string;
  description: string;
  extraClass?: any;
}

const Description: React.FC<DescriptionInterface> = ({
  childOne,
  childTwo,
  title,
  description,
  extraClass,
}) => {
  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 1200 }),
  };

  const shellStyle = resolution.DesktopOrLaptop
    ? style.shell
    : style.shellMobile;

  const titleClass = resolution.DesktopOrLaptop ? 'h1' : 'h1Mobile';

  return (
    <div className={`${shellStyle} ${extraClass}`}>
      <h1 className={titleClass}>{title}</h1>
      {!resolution.DesktopOrLaptop ? childOne || null : null}
      <div className={style.children}>
        {!resolution.DesktopOrLaptop ? childTwo || null : null}
      </div>
      <p className="spanGlobal">{description}</p>
    </div>
  );
};

export default Description;
